import { TransactionDocumentEmissionEstimate } from '@lune-climate/lune'
import { SuccessResponseWithMeta } from '@lune-climate/lune/esm/core/SuccessResponse'
import { TransactionDocumentLineItemsOrFallback } from '@lune-fe/lune-components-lib'
import { FC } from 'react'

interface TransactionDocumentEstimateDetailsProps {
    estimate: SuccessResponseWithMeta<TransactionDocumentEmissionEstimate>
}

export const TransactionDocumentEstimateDetails: FC<TransactionDocumentEstimateDetailsProps> = ({
    estimate,
}) => {
    if (!('lineItems' in estimate)) {
        return null
    }

    return (
        <TransactionDocumentLineItemsOrFallback
            lineItems={estimate.lineItems}
            fallback={estimate.fallback}
            input={estimate._meta.response.request}
            enableEmissionFactorLink={true}
        />
    )
}
